import {createAction} from "@reduxjs/toolkit";

export const setArticles = createAction('SET_ARTICLES');